import React from "react";
import contextProvider from "../../contextProvider";
import { LinkContainer } from "react-router-bootstrap";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, ButtonGroup } from "reactstrap";
import classnames from "classnames";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import Panel from "../../_L1_components/Layout/Panel";
import Section from "../../_L1_components/Layout/Section";
import ReactOTable from "../../_L1_components/Elements/ReactOTable";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";

class MeasureAggregateList extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
      currFreq: "all",
    };
    super(props, initState);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    // console.log(
    //   "DEBUG :: MeasureBssidsList _ onComponentDidMount",
    //   this.getAppContext().getApiStoreService().getCluster()
    // );
    // this.apiStore = this.getAppContext().getApiStoreService();
    //	this.loadProbeUsers();
  }

  onComponentWillUnmount() {
    //		console.log("DEBUG :: MeasureBssidsList _ onComponentWillUnmount");
  }

  parseErr(err) {
    let word = err.substring(3, err.length);
    if (word == "DISCEARLY") {
      return <div>(AP Drop)</div>;
    } else {
      return <div>{`(${word})`}</div>;
    }
  }

  onRender() {
    return this.props.data ? (
      <div>
        <Panel
          className="mx-4 mb-3"
          bodyClassName="p-0"
          rounded
          header={
            "OVERALL INFORMATION"
            // (/ethernet/i.test(this.props.data.essid) ? "NETWORK" : "ESSID")
          }
        >
          {this.props.data.overalData ? (
            <Row noGutters>
              <LinkContainer
                to={{
                  pathname: "/active/aggregate/overal",
                  state: {
                    mlist: this.props.mlist,
                    cssids: this.props.cssids,
                    selectedTags: this.props.selectedTags,
                  },
                }}
                style={{ cursor: "pointer" }}
              >
                <Col className={"d-flex flex-column p-3"}>
                  <div className="d-flex h-100 align-items-center">
                    {this.props.data.overalData.ImgName ? (
                      <img
                        src={
                          this.getAppContext()
                            .getApiStoreService()
                            .getCluster() +
                          "/RRDgrcache/" +
                          this.props.data.overalData.ImgName
                        }
                        className="border border-1 rounded"
                        alt="graph"
                      />
                    ) : (
                      <span>...</span>
                    )}
                  </div>
                </Col>
              </LinkContainer>

              {this.getAppContext().media.isMobile ||
              this.getAppContext().media.isTablet ? (
                <Col xs={12} />
              ) : null}

              <Col>
                <Section
                  className={
                    !this.getAppContext().media.isMobile &&
                    !this.getAppContext().media.isTablet
                      ? "border-top border-gray300"
                      : ""
                  }
                  designType="wide"
                  layoutManager="grid"
                  elementsPerRow={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                      ? 2
                      : !/ethernet/i.test(this.props.data.essid)
                      ? 5
                      : this.getAppContext().isCloud()
                      ? 5
                      : 4
                  }
                  gridSpacing={1}
                  gridSpacingColor={this.getAppContext().colors.gray300}
                  noColFirst={this.getAppContext().isCloud()}
                >
                  <div
                    className={
                      this.getAppContext().isCloud()
                        ? "d-flex flex-column p-3"
                        : "border-left border-gray300 d-flex flex-column p-3"
                    }
                  >
                    <small className="text-muted mb-2">
                      <strong>MEASURES</strong>
                    </small>
                    <div className="d-flex h-100 align-items-center">
                      <h4 id="_mcount_not_available_info_">
                        {this.props.data.overalData.rrd_step == 60
                          ? this.props.data.overalData.measures_count
                          : "--"}
                        {this.props.data.overalData.rrd_step != 60 ? (
                          <span>
                            <ReactOTooltip
                              placement="bottom"
                              target="_mcount_not_available_info_"
                              text={
                                "Data not available for selected view range"
                              }
                            />
                            <span className="sub-title icon-info-outline ml-2" />
                          </span>
                        ) : null}
                      </h4>
                    </div>
                  </div>
                  <div className="d-flex flex-column p-3">
                    <small className="text-muted mb-2">
                      <strong>ERRORS</strong>
                    </small>
                    <div className="d-flex h-100 align-items-center title-3">
                      <h4 id="_ecount_not_available_info_">
                        {this.props.data.overalData.rrd_step == 60
                          ? this.props.data.overalData.errors_count
                          : "--"}
                        {this.props.data.overalData.rrd_step != 60 ? (
                          <span>
                            <ReactOTooltip
                              placement="bottom"
                              target="_ecount_not_available_info_"
                              text={
                                "Data not available for selected view range"
                              }
                            />
                            <span className="sub-title icon-info-outline ml-2" />
                          </span>
                        ) : null}
                      </h4>
                    </div>
                  </div>
                  <div className="d-flex flex-column p-3">
                    <small className="text-muted mb-2">
                      <strong>SLOW MEASURES</strong>
                    </small>
                    <div className="d-flex h-100 align-items-center title-3">
                      <h4 id="_o10count_not_available_info_">
                        {this.props.data.overalData.rrd_step == 60
                          ? this.props.data.overalData.over10_count
                          : "--"}
                        {this.props.data.overalData.rrd_step != 60 ? (
                          <span>
                            <ReactOTooltip
                              placement="bottom"
                              target="_o10count_not_available_info_"
                              text={
                                "Data not available for selected view range"
                              }
                            />
                            <span className="sub-title icon-info-outline ml-2" />
                          </span>
                        ) : null}
                      </h4>
                    </div>
                  </div>
                  <div className="d-flex flex-column p-3">
                    <small className="text-muted mb-2">
                      <strong>SCORE</strong>
                    </small>
                    <div className="d-flex h-100 align-items-center">
                      <h4
                        className={classnames({
                          "text-success":
                            this.props.data.overalData.score >= 80,
                          "text-orange":
                            this.props.data.overalData.score >= 60 &&
                            this.props.data.overalData.score < 80,
                          "text-danger": this.props.data.overalData.score < 60,
                        })}
                      >
                        {this.props.data.overalData.score !== undefined
                          ? this.props.data.overalData.score
                          : "--"}
                      </h4>
                    </div>
                  </div>
                </Section>
              </Col>
            </Row>
          ) : null}
        </Panel>

        <Panel
          className="mx-4 mb-2"
          bodyClassName="p-0"
          rounded
          header={
            <div>
              <div>MEASURES LIST</div>
              <div
                className={
                  !this.getAppContext().media.isMobile
                    ? "d-flex flex-grow-1"
                    : ""
                }
              >
                {this.props.connectionCriteria != "RJ45" &&
                  this.props.freqData &&
                  Object.keys(this.props.freqData).length > 1 && (
                    <div
                      style={
                        this.getAppContext().media.isMobile
                          ? { marginTop: "1em" }
                          : { marginTop: "-1em" }
                      }
                      className="ml-auto"
                    >
                      <ReactOActionBar padding="0">
                        <div style={{ marginTop: "0.2em" }} className="mr-3">
                          Show graphs:
                        </div>
                        <ButtonGroup>
                          <ReactOButton
                            size="sm"
                            className={
                              this.state.currFreq == "all"
                                ? ""
                                : "background-btn"
                            }
                            color={
                              this.state.currFreq == "all" ? "primary" : "light"
                            }
                            onClick={() => {
                              this.setState({
                                currFreq: "all",
                              });
                            }}
                            // disabled={
                            //   this.state.data && this.state.data[0].sync_status == null
                            // }
                          >
                            <strong>
                              All (
                              {(this.props.freqData["2.4"] || 0) +
                                (this.props.freqData["5"] || 0) +
                                (this.props.freqData["6"] || 0)}
                              )
                            </strong>
                          </ReactOButton>
                          {this.props.freqData["2.4"] != null && (
                            <ReactOButton
                              size="sm"
                              className={
                                this.state.currFreq == "2.4"
                                  ? ""
                                  : "background-btn"
                              }
                              color={
                                this.state.currFreq == "2.4"
                                  ? "primary"
                                  : "light"
                              }
                              onClick={() => {
                                this.setState({
                                  currFreq: "2.4",
                                });
                              }}
                              // disabled={
                              //   this.state.data && this.state.data[0].sync_status == null
                              // }
                            >
                              <strong>
                                2.4GHz ({this.props.freqData["2.4"]})
                              </strong>
                            </ReactOButton>
                          )}
                          {this.props.freqData["5"] != null && (
                            <ReactOButton
                              size="sm"
                              color={
                                this.state.currFreq == "5" ? "primary" : "light"
                              }
                              className={
                                this.state.currFreq == "5"
                                  ? ""
                                  : "background-btn"
                              }
                              onClick={() => {
                                this.setState({
                                  currFreq: "5",
                                });
                              }}
                              // disabled={
                              //   this.state.data && this.state.data[0].sync_status == null
                              // }
                            >
                              <strong>5GHz ({this.props.freqData["5"]})</strong>
                            </ReactOButton>
                          )}
                          {this.props.freqData["6"] != null && (
                            <ReactOButton
                              size="sm"
                              color={
                                this.state.currFreq == "6" ? "primary" : "light"
                              }
                              className={
                                this.state.currFreq == "6"
                                  ? ""
                                  : "background-btn"
                              }
                              onClick={() => {
                                this.setState({
                                  currFreq: "6",
                                });
                              }}
                            >
                              <strong>6GHz ({this.props.freqData["6"]})</strong>
                            </ReactOButton>
                          )}
                        </ButtonGroup>
                      </ReactOActionBar>
                    </div>
                  )}
              </div>
            </div>
          }
        >
          <ReactOTable
            thClassName="px-3 py-1"
            tdClassName="align-middle px-3 py-1"
            hoverable
            compressed={
              this.getAppContext().media.isMobile ||
              this.getAppContext().media.isTablet
            }
            compressedRowRendering={(row_items, link) => {
              return link ? (
                <div>
                  <Link className="link-table-test" to={link} target="_blank">
                    <div className="text-center">
                      {row_items.graph_image.content}
                    </div>
                    <div className="mt-2">{row_items.bssid.content}</div>
                    <div className="mt-2">
                      <div className="text-muted">
                        <small className="">
                          <strong>{row_items.status.title}</strong>
                        </small>
                      </div>
                      {row_items.status.content}
                    </div>
                    <Row className="mt-2">
                      <Col>
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items.rssi.title}</strong>
                          </small>
                        </div>
                        {row_items.rssi.content}
                      </Col>
                      <Col>
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items.score.title}</strong>
                          </small>
                        </div>
                        {row_items.score.content}
                      </Col>
                    </Row>
                  </Link>
                </div>
              ) : (
                <div>
                  <div className="text-center">
                    {row_items.graph_image.content}
                  </div>
                  <div className="mt-2">{row_items.bssid.content}</div>
                  <div className="mt-2">
                    <div className="text-muted">
                      <small className="">
                        <strong>{row_items.status.title}</strong>
                      </small>
                    </div>
                    {row_items.status.content}
                  </div>
                  <Row className="mt-2">
                    <Col>
                      <div className="text-muted">
                        <small className="">
                          <strong>{row_items.rssi.title}</strong>
                        </small>
                      </div>
                      {row_items.rssi.content}
                    </Col>
                    <Col>
                      <div className="text-muted">
                        <small className="">
                          <strong>{row_items.score.title}</strong>
                        </small>
                      </div>
                      {row_items.score.content}
                    </Col>
                  </Row>
                </div>
              );
            }}
            thDividers
            defaultSort={[
              {
                data_key: "status",
                order: "desc",
              },
              {
                data_key: "score",
                order: "desc",
              },
              {
                data_key: "rssi",
                order: "desc",
              },
              {
                constrain: "down",
                data_key: "rssi",
                func: (value) => {
                  return value == 0;
                },
              },
            ]}
            onRowClick={
              this.props.onItemClick
                ? this.props.onItemClick
                : (row_data) => {
                    // console.log(row_data);
                  }
            }
            cols={[
              {
                title: "GRAPH",
                //	align: 'center',
                data_key: "graph_image",
                width: "10",
              },
              {
                title: "PROBE",
                align: "center",
                data_key: "probe",
                width: "15",
              },
              {
                title: "NAME",
                align: "center",
                data_key: "name",
                width: "10",
                sortable: true,
              },
              ...(this.getAppContext().isCloud()
                ? [
                    {
                      title: "DIAGNOSTICS",
                      align: "center",
                      data_key: "diag",
                      width: "10",
                      sortable: true,
                    },
                  ]
                : []),
              {
                title: "SCORE",
                align: "center",
                data_key: "score",
                width: "5",
                sortable: true,
              },
              {
                title: "STATUS",
                align: "center",
                data_key: "status",
                width: "5",
                sortable: true,
              },
            ]}
            rows={(() => {
              let _TMP = (
                this.props.data.dataPerBssid ? this.props.data.dataPerBssid : []
              )
                .sort()
                .filter((elem) => {
                  if (
                    elem.last_freq &&
                    Object.keys(elem.last_freq).length > 0
                  ) {
                    if (this.state.currFreq == "2.4") {
                      return elem.last_freq.curr_f < 5000;
                    } else if (this.state.currFreq == "5") {
                      return (
                        elem.last_freq.curr_f > 5000 &&
                        elem.last_freq.curr_f < 5925
                      );
                    } else if (this.state.currFreq == "6") {
                      return elem.last_freq.curr_f >= 5925;
                    } else if (elem.last_freq.curr_f == "0") {
                      return elem;
                    } else {
                      return elem.last_freq.curr_f > 0;
                    }
                  } else {
                    return elem;
                  }
                })
                .map((_CURR_measure, _CURR_idx) => {
                  const cssid = _CURR_measure?.ImgName?.split("@")[0] || "";
                  let bssid = "overal";
                  if (
                    _CURR_measure.bssid &&
                    _CURR_measure.bssid !== "00:00:00:00:00:00"
                  ) {
                    bssid = _CURR_measure.bssid;
                  }
                  const _vp = this.props.viewrange.view_preset;
                  const _hasValidPreset =
                    _vp !== undefined &&
                    _vp !== null &&
                    _vp !== "no" &&
                    this.props.viewrange.is_preset == "yes";
                  return {
                    _link:
                      "/" +
                      _CURR_measure.probeid +
                      "/" +
                      this.props.match.params.status +
                      "/" +
                      cssid +
                      "/" +
                      bssid.replace(/:/g, "") +
                      (_hasValidPreset ? "/" + _vp : ""),
                    cssid: _CURR_measure.cssid || "-",

                    graph_image: (
                      <img
                        src={
                          this.getAppContext()
                            .getApiStoreService()
                            .getCluster() +
                          "/RRDgrcache/" +
                          _CURR_measure.ImgName
                        }
                        className="border border-1 rounded"
                        alt="graph"
                      />
                    ),
                    //	bssid_count: _CURR_measure.dataPerBssid.length,
                    score: {
                      value: _CURR_measure.score,
                      render: (
                        <span
                          className={classnames({
                            "text-success": _CURR_measure.score >= 80,
                            "text-orange":
                              _CURR_measure.score >= 60 &&
                              _CURR_measure.score < 80,
                            "text-danger": _CURR_measure.score < 60,
                          })}
                        >
                          {_CURR_measure.score}
                        </span>
                      ),
                    },
                    status: {
                      value: _CURR_measure.paused,
                      render: _CURR_measure.paused ? (
                        <div className="text-orange">
                          <span className="icon-pause mr-2" />
                          Paused
                          <div className="sub-title">
                            (
                            {this.getAppContext()
                              .momentjs(_CURR_measure.paused, "X")
                              .format("L LT")}
                            )
                          </div>
                        </div>
                      ) : (
                        <div className="text-success">Running</div>
                      ),
                    },
                    probe: {
                      value: _CURR_measure.probeid,
                      render: (
                        <div className="text-center">
                          <h4>{_CURR_measure.probename || "-"}</h4>
                          <div className="sub-title">
                            {_CURR_measure.probeid.match(/.{1,2}/g).join(":")}
                          </div>
                        </div>
                      ),
                    },
                    name: <h5>{_CURR_measure.name}</h5> || "-",
                    ...(this.getAppContext().isCloud()
                      ? {
                          diag: _CURR_measure.diagnostics.last_state
                            ? {
                                value:
                                  this.getAppContext().conf
                                    .MLY_STATES_DICTIONARY[
                                    _CURR_measure.diagnostics.last_state
                                  ].value,
                                render: (
                                  <div id={"tp-" + _CURR_idx + "-diag"}>
                                    <span
                                      className={
                                        _CURR_measure.diagnostics.last_state ==
                                          "N" ||
                                        _CURR_measure.diagnostics.last_state ==
                                          "U"
                                          ? "text-" +
                                            this.getAppContext().conf
                                              .MLY_STATES_DICTIONARY[
                                              _CURR_measure.diagnostics
                                                .last_state
                                            ].color
                                          : "text-" +
                                            _CURR_measure.diagnostics.color
                                      }
                                    >
                                      {_CURR_measure.diagnostics.err_step &&
                                      _CURR_measure.diagnostics.err_step
                                        .length > 0 ? (
                                        <ReactOTooltip
                                          placement="bottom"
                                          target={"tp-" + _CURR_idx + "-diag"}
                                          text={
                                            <div>
                                              {this.getAppContext().getDiag(
                                                _CURR_measure.diagnostics
                                                  .last_state,
                                                _CURR_measure.diagnostics
                                                  .consideration
                                              )}
                                              {this.getAppContext().getErrWording(
                                                _CURR_measure.diagnostics
                                                  .err_step
                                              )}
                                              {/* {_CURR_measure.diagnostics.err_step.substring(
                                                  0,
                                                  2
                                                ) == "MO"
                                                  ? " mostly on " +
                                                    _CURR_measure.diagnostics.err_step.substring(
                                                      3,
                                                      _CURR_measure.diagnostics.err_step
                                                        .length
                                                    )
                                                  : " on " +
                                                    _CURR_measure.diagnostics.err_step.substring(
                                                      3,
                                                      _CURR_measure.diagnostics.err_step
                                                        .length
                                                    )} */}
                                              <div>
                                                {_CURR_measure.diagnostics
                                                  .term &&
                                                _CURR_measure.diagnostics
                                                  .term == 2
                                                  ? " (previous 4h)"
                                                  : " (last period)"}
                                              </div>
                                            </div>
                                          }
                                        />
                                      ) : null}
                                      <h4>
                                        {this.getAppContext().getDiag(
                                          _CURR_measure.diagnostics.last_state,
                                          _CURR_measure.diagnostics
                                            .consideration
                                        )}{" "}
                                        {_CURR_measure.diagnostics.err_step &&
                                        _CURR_measure.diagnostics.err_step
                                          .length > 0
                                          ? this.parseErr(
                                              _CURR_measure.diagnostics.err_step
                                            )
                                          : null}
                                      </h4>
                                      <div className="sub-title">
                                        since{" "}
                                        {_CURR_measure.diagnostics.last_state_ts
                                          ? this.getAppContext()
                                              .momentjs(
                                                _CURR_measure.diagnostics
                                                  .last_state_ts,
                                                "X"
                                              )
                                              .format("L LT")
                                          : "-"}
                                      </div>
                                    </span>
                                  </div>
                                ),
                              }
                            : {
                                value:
                                  this.getAppContext().conf
                                    .MLY_STATES_DICTIONARY["NA"].value,
                                render: (
                                  <div
                                    className={
                                      "text-" +
                                      this.getAppContext().conf
                                        .MLY_STATES_DICTIONARY["NA"].color
                                    }
                                  >
                                    {
                                      this.getAppContext().conf
                                        .MLY_STATES_DICTIONARY["NA"].text
                                    }
                                  </div>
                                ),
                              },
                        }
                      : {}),
                  };
                });
              return _TMP;
            })()}
          />
        </Panel>
        {this.props.data?.dataPerBssid &&
        this.props.data.dataPerBssid.length == 1 &&
        !/ethernet/i.test(this.props.data.essid) ? (
          <small className="mx-4 mb-4 text-muted d-flex align-items-center">
            <span className="icon-info mr-1" style={{ fontSize: "130%" }} />A
            single access point was tested for the given measure criteria and
            period
          </small>
        ) : null}
      </div>
    ) : null;
  }
}

export default contextProvider(
  withRouter(MeasureAggregateList),
  //	withDefinedContext(MeasureBssidsList, 'MeasureBssidsList', context_exposed_methods),
  {
    define: null,
  }
);
